import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Entity, NotificationResponse, RoleType } from "../../App/enums"
import { organizationProfileDefault, profileDefault } from "../../App/GlobaleVariables"
import HTTPService from "../../App/HTTPService"
import { selectTranslations } from "../../App/i18n/i18nSlice"
import { RootState } from "../../App/store"
import { setRoomMembers } from "../Room/RoomSlices/MembersInRoomSlice"
import { CubeIconSmall, NotificationUnnreadIcon } from "../Shared/Components/SvgIcons"
import Button from "../Shared/Primitive/Button"
//import { setUserNotifications } from "./NotificationSlice"
//import { getMembersRequest, userNotificationGetRequest } from "./UserNotificationServiceRequest"
import { setModalData } from "../Shared/SharedSlices/ModalSlice"
import Image from "../Shared/Primitive/Image"

function UpcomingEventsDropdownItem(props: {
    id: number
    sender?: string
    action_url?: string
    redirect_url?: string
    name?: string
    notification?: string
    date: string
    isRead?: boolean
    post?: number
    onClick?: () => void
    isLastItem: boolean
    roomId: number
    roomName: string
    invitation_id?: number
    isDropDown?: boolean
    location: string
    format: string
    image?: string
}) {
    const translation = useSelector(selectTranslations)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { id } = useParams()

    return (
        <div
            className={`notification-dropdown-item notification-dropdown-item--${props.isLastItem && "border-none"} notification-dropdown-item--${!props.isRead && "color-grey"
                }`}
        >
            <div className="notification-dropdown-item__content">
                <div className="notification-dropdown-item__left-panel-no-padding" onClick={props.onClick}>
                    <div className="room-events__item-date-small">
                        <div className='room-events__item-date-day'>
                            {new Date(props.date).toLocaleDateString(undefined, { day: 'numeric' })}
                        </div>
                        <div className='room-events__item-date-month'>
                            {new Date(props.date).toLocaleDateString(undefined, { month: 'short' })}
                        </div>
                    </div>
                </div>
                {!props.isDropDown && (
                    <div className="notification-dropdown-item__image-panel">
                        <div className="room-events__dropdown-image-container">
                        {props?.image ? (<Image src={props.image} className="room-events__dropdown-image" />) : (
                            <Image src="/event_default.png" className="room-events__dropdown-image" />
                        )}
                    </div>
                    </div>
                )}
                <div className={`notification-dropdown-item__middle-panel`}>
                    
                    <div className={`notification-dropdown-item__event-name`} onClick={props.onClick}>
                        {props.name}
                    </div>
                    <div
                        className={`notification-dropdown-item__notification notification-dropdown-item__notification--margin-bottom`}
                        onClick={props.onClick}
                    >
                        <p>{new Date(props.date).toLocaleString()}</p>
                        {props.location} - {props.format}
                        <p style={{ display: "flex", alignItems: "left", marginLeft: "-0.4rem" }}>
                            <CubeIconSmall />
                            {props.roomName}
                        </p>
                    </div>
                </div>
            </div>

            
        </div>
    )
}

export default UpcomingEventsDropdownItem
